import { Component } from 'react'
import Slider from 'react-slick'
import Lightbox from 'react-images'

const theme = {
  footerCaption: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '16px',
  },
}

export default class DeckPlans extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      currentImage: 0,
    }
  }

  gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage - 1,
    })
  }

  gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1,
    })
  }

  gotoImage = (index) => {
    this.setState({
      currentImage: index,
    })
  }

  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      isOpen: false,
    })
  }

  render() {
    const settings = {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: false,
      dots: true,
      responsive: [{
        breakpoint: 768, settings: { arrows: false, slidesToShow: 1.2, slidesToScroll: 1, dots: false },
      }],
    }

    if((!this.props.deckPlans || this.props.deckPlans) && !this.props.deckPlans.length) {
      return ''
    }

    return (
      <div className='deck-plans'>
        <Lightbox
          images={this.props.deckPlans}
          currentImage={this.state.currentImage}
          isOpen={this.state.isOpen}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          width={window.innerWidth * 0.9}
          onClickThumbnail={this.gotoImage}
          showThumbnails
          theme={theme}
          onClose={this.closeLightbox}
        />
        <div className='deck-plan'>
          <Slider className='slick-pt-custom' {...settings}>
            { this.props.deckPlans.map((deck, index) => {
              return (<div className='deck-plans__image-container' key={index} onClick={() => {
                this.setState({ isOpen: true })
              }}>
                <span className='deck-plans__image pointer'
                  style={{ backgroundImage: `url(${deck.thumbnailUrl})` }} />
              </div>)
            })
            }
          </Slider>
        </div>
      </div>
    )
  }
}
